import isEqual from "lodash.isequal";
import pick from "lodash.pick";

export function checkUpdateAddress(oldAddress = {}, newAddress = {}) {
  const fields = [
    "address1",
    "address2",
    "city",
    "region",
    "postalCode",
    "country",
    "location",
  ];
  return !isEqual(pick(oldAddress, fields), pick(newAddress, fields));
}
